export default "__VITE_ASSET__AIEmnZ_r__"